import { render } from "./origins-area.vue?vue&type=template&id=cc2aa1c2"
import script from "./origins-area.vue?vue&type=script&lang=js"
export * from "./origins-area.vue?vue&type=script&lang=js"

import "./origins-area.vue?vue&type=style&index=0&id=cc2aa1c2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__